/* assets/wishlist.js */
(() => {
  const KEY = 'se-wishlist';

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch { return []; }
  };
  const write = (list) => localStorage.setItem(KEY, JSON.stringify(list));

  const idEq = (a, b) => String(a) === String(b);

  // есть ли товар в избранном
  const has = (list, id) => list.some(x => idEq(x?.id ?? x, id));

  // добавить/убрать товар
  const toggleInStorage = (id, handle) => {
    let list = read();
    const i = list.findIndex(x => idEq(x?.id ?? x, id));
    if (i > -1) {
      list.splice(i, 1);
    } else {
      // храним объект, чтобы в будущем можно было отрендерить страницу wishlist
      list.push({ id: String(id), handle: handle || null });
    }
    write(list);
    return list.length;
  };

  // покрасить все кнопки данного id
  const paintAll = (id, active) => {
    document.querySelectorAll(`.wishlist-button[data-product-id="${CSS.escape(String(id))}"]`)
      .forEach(btn => btn.classList.toggle('is-active', active));
  };

  // первичная раскраска всех кнопок на странице
  const hydrateButtons = () => {
    const list = read();
    document.querySelectorAll('.wishlist-button').forEach(btn => {
      const id = btn.dataset.productId;
      btn.classList.toggle('is-active', has(list, id));
    });
    updateHeaderBadge(list.length);
  };

  // бейдж в хедере (обновляем все — десктоп + мобайл)
  const updateHeaderBadge = (count) => {
    document.querySelectorAll('[data-wishlist-count]').forEach(badge => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  };

  // делегируем клики
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.wishlist-button');
    if (!btn) return;

    e.preventDefault();
    const id = btn.dataset.productId;
    const handle = btn.dataset.productHandle;

    // toggle в storage
    const listLen = toggleInStorage(id, handle);

    // sync все дубли
    const nowActive = has(read(), id);
    paintAll(id, nowActive);
    updateHeaderBadge(listLen);

    // уведомляем мобильный бейдж и другие слушатели
    document.dispatchEvent(new CustomEvent('wishlist:update'));
  });

  // инициализация
  const init = () => hydrateButtons();

  document.addEventListener('DOMContentLoaded', init);
  // на всякий — когда секции перезагружаются в админке/темах
  document.addEventListener('shopify:section:load', init);
})();